import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const ProtocolListSkeleton: FC = () => {
  return (
    <>
      {Array.from({ length: 20 }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: 15 }).map((_, colIndex) => (
            <td key={colIndex}>
              <Skeleton height={40} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};
